<template>
  <fieldset class="sm:col-span-2">
    <legend class="w-full mb-1 text-sm font-semibold cursor-default">
      Is the patient the insurance policy holder?
    </legend>
    <div class="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
      <form-radio
        v-for="(option, index) in options"
        :key="index"
        :id="`${option.value}-${fieldName}`"
        :value="option.value"
        v-model="internalValue"
        @change="onInput"
        >{{ option.label }}</form-radio
      >
    </div>
  </fieldset>
</template>

<script>
import { FormRadio } from "@/components/Form/";

export default {
  components: { FormRadio },
  props: ["value"],
  data() {
    return {
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
      internalValue: true,
    };
  },
  computed: {
    fieldName() {
      return this.$vnode.key;
    },
  },
  watch: {
    value: {
      handler(val) {
        this.internalValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    onInput(val) {
      this.$emit("input:field", val);
    },
  },
};
</script>
